import { useState } from "react";
import { Input } from "@/components/ui/input";
import { ChevronDown } from "lucide-react";
import { COUNTRIES } from "@/lib/countries";
import { flagUrl } from "@/lib/flag";

const byCode = (code) => COUNTRIES.find((c) => c.code === code);

// Retire le préfixe indicatif d'un numéro complet pour n'afficher que la partie locale.
const stripDial = (phone, dial) => {
  if (!phone) return "";
  const p = phone.trim();
  if (dial && p.startsWith(dial)) return p.slice(dial.length).trim();
  return p.replace(/^\+?\d+\s/, "").trim() || p;
};

// Sélecteur d'indicatif NATIF (<select>) : fonctionne sur tous les téléphones/tablettes/ordinateurs,
// même à l'intérieur d'une boîte de dialogue (contrairement au popover précédent).
export const PhoneInput = ({ code = "FR", phone = "", onChange, testid = "phone" }) => {
  const selected = byCode(code) || byCode("FR");
  const [number, setNumber] = useState(() => stripDial(phone, selected?.dial));

  const emit = (nextCode, nextNumber) => {
    const c = byCode(nextCode) || selected;
    const full = nextNumber ? `${c.dial} ${nextNumber}`.trim() : "";
    onChange?.({ code: nextCode, phone: full, dial: c.dial, number: nextNumber });
  };

  const onSelectCode = (e) => emit(e.target.value, number);
  const onNumber = (e) => {
    const val = e.target.value.replace(/[^\d\s]/g, "");
    setNumber(val);
    emit(selected.code, val);
  };

  return (
    <div className="flex gap-2">
      <div className="relative flex w-[7.5rem] shrink-0 items-center rounded-xl border border-white/10 bg-white/[0.04] focus-within:ring-1 focus-within:ring-sky-400">
        <img src={flagUrl(selected?.code)} alt="" className="pointer-events-none absolute left-2.5 h-3.5 w-5 rounded-[2px] object-cover" />
        <span className="pointer-events-none absolute left-9 text-sm text-foreground">{selected?.dial}</span>
        <ChevronDown size={14} className="pointer-events-none absolute right-2 opacity-60" />
        <select
          value={selected?.code}
          onChange={onSelectCode}
          data-testid={`${testid}-dialcode`}
          aria-label="Indicatif du pays"
          className="h-11 w-full cursor-pointer appearance-none bg-transparent pl-9 pr-6 text-sm text-transparent outline-none"
        >
          {COUNTRIES.map((c) => (
            <option key={c.code} value={c.code} className="bg-white text-black">{`${c.name} (${c.dial})`}</option>
          ))}
        </select>
      </div>
      <Input type="tel" inputMode="tel" placeholder="6 12 34 56 78" value={number} onChange={onNumber} className="h-11 rounded-xl border-white/10 bg-white/[0.04]" data-testid={`${testid}-number`} />
    </div>
  );
};
